import React from 'react'
import { cls } from '@utils/classnames'

interface FileUploaderDragAndDropProperties {
  title?: string
  inputName: string
  uploadFailedText?: string
  handleFileInputChange: (argument: FileList, inputReference: React.MutableRefObject<HTMLInputElement | null>) => void
}

const FileUploaderDragAndDrop: React.FC<FileUploaderDragAndDropProperties> = ({
  title,
  inputName,
  handleFileInputChange,
}: FileUploaderDragAndDropProperties): JSX.Element => {
  const inputReference = React.useRef<HTMLInputElement>(null)
  const [dragActive, setDragActive] = React.useState<boolean>(false)

  function handleInput(event: React.ChangeEvent<HTMLInputElement>) {
    event.preventDefault()

    if (event.target.files && event.target.files[0]) {
      handleFileInputChange(event.target.files, inputReference)
    }
  }

  function handleDrag(event: React.DragEvent<HTMLElement>) {
    event.preventDefault()
    event.stopPropagation()
    if (event.type === 'dragenter' || event.type === 'dragover') {
      setDragActive(true)
    }
    if (event.type === 'dragleave') {
      setDragActive(false)
    }
  }

  function handleDrop(event: React.DragEvent<HTMLElement>) {
    event.preventDefault()
    event.stopPropagation()

    setDragActive(false)
    if (event.dataTransfer.files) {
      handleFileInputChange(event.dataTransfer.files, inputReference)
    }
  }

  return (
    <div className="cmp-file-uploader-drag-and-drop" onDragEnter={handleDrag}>
      <input
        ref={inputReference}
        type="file"
        id="file-upload__input"
        className="cmp-file-uploader-drag-and-drop__input sr-only"
        name={inputName}
        multiple
        aria-describedby="upload-rules"
        onInput={handleInput}
      />
      <label
        htmlFor="file-upload__input"
        className={cls({
          'cmp-file-uploader-drag-and-drop__label': true,
          'cmp-file-uploader-drag-and-drop__label--is-drag-active': dragActive,
        })}
      >
        <div>
          <div className="cmp-file-uploader-drag-and-drop__icon">
            <i className="ri-upload-line"></i>
          </div>
          <p className="cmp-file-uploader-drag-and-drop__title">{title}</p>
        </div>
      </label>
      {dragActive && (
        <div
          id="drag-file-element"
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        ></div>
      )}
    </div>
  )
}

export default FileUploaderDragAndDrop
